import gql from 'graphql-tag';

export const GET = gql`
  query getCourse($input: GetCourseInput!) {
    getCourse(input: $input) {
      id
      title
      price
      priceId
      isPublic
      isFree
      duration
      description
      thumbnail
      seoName
      content
      type
      status
      message
      lessons {
        title
      }
      skills
      owner {
        id
        name
        description
        profilePath
        totalCourses
        totalReviews
        avgRate
        rates {
          percent
          total
          value
        }
      }
      createdBy
      updatedTime
      createdTime
    }
  }
`;

export const LIST = gql`
  query listCourse($input: ListCourseInput!) {
    listCourse(input: $input) {
      id
      title
      price
      type
      status
      isPublic
      duration
      thumbnail
      description
    }
  }
`;

export const LIST_PUBLIC = gql`
  query listCoursesPublic($input: ListCoursesPublicInput!) {
    listCoursesPublic(input: $input) {
      page
      totalPages
      header {
        banner
        bannerBlur
        title
        description
      }
      featureCourses {
        id
        thumbnail
        title
        price
        isFree
        description
        owner {
          id
          name
          profilePath
        }
        createdTime
      }
      results {
        id
        title
        price
        isFree
        isPublic
        duration
        thumbnail
        description
        seoName
        owner {
          id
          name
          profilePath
        }
        # lessons {
        #   title
        # }
        # syllabus {
        #   bookId
        #   time
        #   title
        #   description
        #   lessons
        #   skills
        # }
      }
    }
  }
`;

export const GET_COURSE_LIST = gql`
  query getCourseList($input: GetCourseListInput!) {
    getCourseList(input: $input) {
      page
      totalPages
      results {
        id
        title
        type
        status
        isPublic
        thumbnail
        owner {
          id
          name
          profilePath
        }

        updatedTime
        createdTime
      }
    }
  }
`;

export const SEARCH = gql`
  query searchCourses($input: SearchCoursesInput!) {
    searchCourses(input: $input) {
      page
      totalPages
      results {
        id
        title
        price
        priceId
        isPublic
        duration
        thumbnail
        description
        # syllabus {
        #   bookId
        #   time
        #   title
        #   description
        #   details
        #   lessons
        #   skills
        # }
      }
    }
  }
`;

export const LIST_RECENT = gql`
  query listRecentCourses($input: ListRecentCoursesInput!) {
    listRecentCourses(input: $input) {
      courses {
        id
        title
        isFree
        price
        isPublic
        duration
        thumbnail
        description
        # syllabus {
        #   bookId
        #   time
        #   title
        #   description
        #   details
        #   lessons
        #   skills
        # }
      }
      page
    }
  }
`;
